import * as THREE from 'three'
import type { SceneArt } from '../data/cutscenes'

/** One underwater world, with daylight fading as the route descends. Local
 * architecture and practical lamps supply identity, rather than unrelated sky hues. */
export function dioramaArt(scene: SceneArt) {
  const cave = scene === 'coralcave' || scene === 'royalcave' || scene === 'throne'
  const deep = scene === 'deepsea' || scene === 'ship'
  const storm = scene === 'storm'
  return {
    haze: deep ? 0x163742 : cave ? 0x233b4b : storm ? 0x244653 : 0x126e92,
    ground: deep ? 0x536567 : cave ? 0x647078 : 0xb9aa83,
    key: cave ? 0xffd4a1 : storm ? 0xc4d6e2 : 0xffead0,
    fill: 0x76cde9,
    rim: cave ? 0x81b8cf : 0x8ae6ff,
    accent: cave || scene === 'ship' ? 0xe8b471 : 0x93c8cf,
    fogDensity: deep ? 0.034 : cave ? 0.027 : 0.024,
  }
}

/** Small-scale sand/silt relief. Repeating bumps catch directional light while
 * broad ripples reinforce the miniature's physical scale without adding draws. */
export function createSeabedRelief(): THREE.DataTexture {
  const size = 256
  const pixels = new Uint8Array(size * size * 4)
  for (let y = 0; y < size; y++) for (let x = 0; x < size; x++) {
    const grain = ((x * 1973 + y * 9277 + x * y * 26699) >>> 0) % 43
    const ripple = Math.sin(x * Math.PI / 16 + Math.sin(y * Math.PI / 64) * 1.4)
    const value = 125 + ripple * 31 + grain
    const i = (y * size + x) * 4
    pixels[i] = pixels[i + 1] = pixels[i + 2] = value
    pixels[i + 3] = 255
  }
  const map = new THREE.DataTexture(pixels, size, size, THREE.RGBAFormat)
  map.name = 'MiniatureSeabedRelief'
  map.wrapS = map.wrapT = THREE.RepeatWrapping
  map.repeat.set(5, 5)
  map.magFilter = THREE.LinearFilter
  map.minFilter = THREE.LinearMipmapLinearFilter
  map.generateMipmaps = true
  map.needsUpdate = true
  return map
}
